module.exports = __webpack_public_path__ + "static/img/05_pro.8cdc263.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/05_pro.jpg
// module id = Dgbj
// module chunks = 0